<template>
    <MainContent title="Editar boletín">
        <template v-slot:header>
            <h3 class="card-title p-0">Editar boletín</h3>
        </template>
        <template v-slot:content>
            <ContentOrLoading>
                <Stepper
                    v-if="Object.keys(boletin).length"
                    ref="stepper"
                    :steps="steps" 
                >
                    <template #pasoDatos="{ changeStep }">
                        <PasoUnoComponent :boletin.sync="boletin" :loading="loading" @finalizarPasoUno="changeStep" />
                    </template>
                    <template #pasoDesign>
                        <PasoDosComponent :boletin.sync="boletin" :loading="loading" @update:boletin="editarBoletin" />
                    </template>
                </Stepper>
            </ContentOrLoading>
        </template>
    </MainContent>
</template>

<script>
    import apiService from '@/services/api-comunicados';
    import MainContent from '@/components/backend/components/MainContent';
    import Stepper from '@/components/frontend/events/compra/components/Stepper.vue';
    import PasoUnoComponent from '@/components/backend/campana-emails/boletines/PasoUnoComponent';
    import PasoDosComponent from '@/components/backend/campana-emails/boletines/PasoDosComponent';

    export default {
        props: {
            boletin_id: {
                type: [Number, String],
                required: true
            }
        },
        data() {
            return {
                boletin: {},
                loading: false,
                steps: [
                    { label: "Rellena los datos", slot: "pasoDatos" },
                    { label: "Diseño", slot: "pasoDesign" }
                ]
            }
        },
        methods: {
            async getBoletin() {
                this.loading = true;

                try {
                    const response = await apiService.getBoletin(this.boletin_id);
                    this.boletin = response.data;
                } catch (error) {
                    this.$toast.error("Error al recuperar el boletín");
                } finally {
                    this.loading = false;
                }
            },
            async editarBoletin() {
                this.loading = true;

                try {
                    const payload = {
                        asunto: this.boletin.asunto,
                        contenido: this.boletin.contenido,
                        remitente_id: this.boletin.remitente?.id,
                        carpetas_comunicados: this.boletin.carpetas_comunicados.map(c => c.id),
                        grupos_ids: this.boletin.grupos.map(g => g.id),
                        fecha_envio_programado: this.boletin.fecha_envio_programado
                    };

                    const response = await apiService.updateBoletin(this.boletin_id, payload);
                    this.$toast.success('Boletín editado correctamente');
                    this.$router.push('/admin/emails/boletines');
                } catch (error) {
                    console.error('Error al editar boletín:', error);
                    this.$toast.error('Error al editar boletín');
                } finally {
                    this.loading = false;
                }
            }
        },
        created() {
            this.getBoletin();
        },
        components: {
            Stepper, MainContent, PasoUnoComponent, PasoDosComponent
        }
    }
</script>